import { MeshPhysicalMaterial, MeshStandardMaterial } from "three";
import { OpdekGLTFResult } from "../opdek/OpdekType";
import { ScharnierGLTFResult } from "../scharnier/ScharnierType";
import { SchuifGLTFResult } from "../schuif/SchuifType";
import { TaatsGLTFResult } from "../taats/TaatsType";
import {
  bottomBeamOverlapScale,
  useLayoutAdjustments,
} from "./useLayoutAdjustments";

export const DeWaalCutLayouts = ({
  chosenMaterial,
  nodes,
  doorIndex,
}: {
  chosenMaterial: MeshPhysicalMaterial | MeshStandardMaterial;
  nodes:
    | OpdekGLTFResult["nodes"]
    | TaatsGLTFResult["nodes"]
    | SchuifGLTFResult["nodes"]
    | ScharnierGLTFResult["nodes"];

  doorIndex: number;
}) => {
  const {
    scaleDoorX,
    scaleDoorY,
    scaleDoorYCut,
    layoutOffsetX,
    doorCutYAdjustment,
    isCutLayout,
  } = useLayoutAdjustments({ doorIndex });

  return (
    <group>
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.beam_dewaal_B.geometry}
        material={chosenMaterial}
        position={[-0.076 * scaleDoorX + layoutOffsetX, 2.033 * scaleDoorY, 0]}
        scale-y={scaleDoorY}
        scale-x={scaleDoorX}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.beam_dewaal_A.geometry}
        material={chosenMaterial}
        position={[0.165 * scaleDoorX + layoutOffsetX, 0.299 * scaleDoorY, 0]}
        //Taatsdeur + dubbel beams to touch bottom frame
        scale-y={scaleDoorY * bottomBeamOverlapScale}
        scale-x={scaleDoorX}
        visible={!isCutLayout}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.beam_dewaal_A_lower_part.geometry}
        material={chosenMaterial}
        position={[
          0.165 * scaleDoorX + layoutOffsetX,
          0.814 * scaleDoorYCut + doorCutYAdjustment,
          0,
        ]}
        scale-y={scaleDoorYCut}
        scale-x={scaleDoorX}
      />
    </group>
  );
};
